<template>
  <nav>
    <!-- <router-link to="/">Home</router-link> 
    <router-link to="/about">About</router-link> -->
  </nav>
  <router-view />
  
</template>
<script>
export default{
  mounted(){
    // this.requestFullScreen()
  },
  methods:{
    requestFullScreen() {
      const el = document.documentElement; // کل صفحه

      if (el.requestFullscreen) {
        el.requestFullscreen();
      } else if (el.webkitRequestFullscreen) { // Safari
        el.webkitRequestFullscreen();
      } else if (el.msRequestFullscreen) { // IE11
        el.msRequestFullscreen();
      }
    }
  }
}
</script>
<style lang="scss">
 
#app {
  font-family: IRANSansWeb, Nahid;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
:root {
  --color-primary: #005bbb; /* آبی سلطنتی */
  --color-secondary: #ffd500; /* زرد روشن */
  --color-bg: #e0e0e0; /* زمینه روشن */
  --color-text: #212529; /* متن اصلی */
  --color-success: #28a745; /* موفقیت */
  --color-danger: #dc3545; /* خطا */
}
body {
  background: var(--color-bg) !important;
}
.my-swal-rtl {
  direction: rtl;
  text-align: right;
  font-family: IRANSansWeb, Nahid; /* یا هر فونت فارسی دیگه */
}
.Pointer {
  cursor: pointer;
}
.bg-Defult {
  background-color: #441ea5 !important;
  color: rgb(0, 0, 0);
}
.font-20 {
  font-size: 22px !important;
}
.wronginput {
  border-color: rgba(230, 39, 39, 0.8) !important;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(226, 53, 47, 0.6) !important;
  outline: 0 none !important;
}

.wronginput:focus {
  border-color: rgba(230, 39, 39, 0.8) !important;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(226, 53, 47, 0.6) !important;
  outline: 0 none !important;
}
.hover-danger:hover {
  color: #a11414 !important;
  cursor: pointer;
}
.hover-success:hover {
  color: #7ba509 !important;
  cursor: pointer;
}
.hover-warning:hover {
  color: #c9a70f !important;
  cursor: pointer;
}
.hover-info:hover {
  color: #0f5fbb !important;
  cursor: pointer;
}
.vpd-input-group{
  height: 35px;
}
.fal-size {
  font-size: 20px;
}
.btn-primary {
  background-color: #441ea5;
  border: none;
}
.btn-outline-primary {
  border-color: #441ea5;
  color: #441ea5;
}
.btn-outline-primary:hover {
  background-color: #441ea5;
  color: white;
}
.btn-warning {
  background-color: #eca202;
  color: #fff;
}
// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>
